import React from 'react';
import "animate.css/animate.min.css";
import ScrollAnimation from 'react-animate-on-scroll';
import about3 from '../../assets/image/about3.png'


class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNavOpen: false
    };
  }


  render() {
    return (
      <section id='about' className='about-section-6 bg-light'>
        <div class="row d-flex bg-light m-0">
          <div class="col-md-6 d-flex align-items-center">
            <div class="row justify-content-center py-5">
              <div class="col-md-10">
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={100}>
              <h1 class="mb-4">Quiénes somos</h1>
              </ScrollAnimation>
              <ScrollAnimation animateIn="animate__fadeIn" animateOnce={true} delay={150}>
              <p class="mb-4 pb-2">Nuestra empresa se dedica a promover la adopción de energías renovables para construir un futuro sostenible. Con una amplia experiencia en la industria, nos apasiona proporcionar soluciones energéticas limpias y eficientes. Trabajamos con clientes de diversos sectores para implementar sistemas de energía renovable personalizados que reducen la dependencia de los combustibles fósiles y minimizan el impacto ambiental.</p>
              </ScrollAnimation>
              </div>
            </div>
          </div>
          <div class="col-md-6 " style={{ backgroundImage: `url(${about3})`, height: '450px', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', }} >
          </div>
        </div>
      </section>
    );
  }
}

export default About;